import { render, staticRenderFns } from "./LandingQuestions.vue?vue&type=template&id=3bbceb79&scoped=true&"
import script from "./LandingQuestions.vue?vue&type=script&lang=js&"
export * from "./LandingQuestions.vue?vue&type=script&lang=js&"
import style0 from "./LandingQuestions.vue?vue&type=style&index=0&id=3bbceb79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbceb79",
  null
  
)

export default component.exports